import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { LoggerModule, Logger } from '@dx/common';
import { ToastModule, SharedModule as DxSharedModule } from '@dx/platform-components';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faSpinnerThird, faExternalLinkAlt } from '@fortawesome/pro-light-svg-icons';
import { faCircle, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { NgbDropdownModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthInterceptor } from './auth/auth.interceptor';
import { AppAuthErrorComponent } from './components/app-auth-error/app-auth-error.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { AppNavbarComponent } from './components/app-navbar/app-navbar.component';
import { configFactory } from './services/config.service.factory';
import { ConfigService } from './services/config.service';
import { FooterComponent } from './components/footer/footer.component';
import { GoToInputModule } from './components/go-to-input/go-to-input.module';
import { HeaderCurveModule } from './components/header-curve/header-curve.module';
import { loggerFactory } from './logger/logger.service.factory';
import { SessionExpiredModalComponent } from './components/session-expired-modal/session-expired-modal.component';
import { UserDetailComponent } from './components/user-detail/user-detail.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FontAwesomeModule,
        NgbDropdownModule,
        NgbModalModule,
        GoToInputModule,
        HeaderCurveModule,
        LoggerModule,
        ToastModule,
        DxSharedModule
    ],
    declarations: [
        AppAuthErrorComponent,
        AppHeaderComponent,
        AppNavbarComponent,
        FooterComponent,
        SessionExpiredModalComponent,
        UserDetailComponent
    ],
    exports: [
        AppHeaderComponent,
        FooterComponent,
        HeaderCurveModule
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: configFactory,
            multi: true,
            deps: [ConfigService]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: Logger,
            useFactory: loggerFactory,
            deps: [ConfigService]
        }
    ]
})
export class CoreModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faSpinnerThird, faCircle, faChevronRight, faExternalLinkAlt);
  }
}
